import { playButtonActionTypes } from '@/components/playButton/Constants';

import type { PlayButtonActions, PlayButtonState } from '@/components/playButton/types';

const initialState: PlayButtonState = {
	loading: false,
	paused: false,
	autoPlay: false,
	error: '',
	isAudioPlaying: false,
};

export default function playButtonReducer(
	state = initialState,
	action: PlayButtonActions,
): PlayButtonState {
	const { type, payload } = action;

	switch (type) {
		case playButtonActionTypes.GET_SONG_REQUEST:
			return {
				...state,
				requestData: {
					word: payload.word,
					lang: payload.lang,
				},
				shouldHighlight: payload.shouldHighlight,
				loading: true,
			};
		case playButtonActionTypes.GET_SONG_SUCCESS:
			return {
				...state,
				songId: payload.id,
				song: { ...payload.song },
				loading: false,
			};
		case playButtonActionTypes.REMOVE_SONG:
			return {
				...state,
				songId: null,
				song: null,
				requestData: null,
				paused: false,
				loading: false,
			};
		case playButtonActionTypes.PAUSE_SONG:
			return {
				...state,
				paused: payload.paused,
			};

		case playButtonActionTypes.IS_AUDIO_PLAYING:
			return {
				...state,
				isAudioPlaying: payload.isAudioPlaying,
				loading: payload.isProcessing,
			};

		case playButtonActionTypes.SET_SONG_ID:
			return {
				...state,
				songId: payload.id,
			};

		default:
			return state;
	}
}
